import {Component, ChangeDetectionStrategy} from '@angular/core';
import {RewardsAdminService} from '../../../../services/rewards-admin/rewards-admin.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';

@Component({
    selector: 'app-superadmin-import-rewards',
    templateUrl: './superadmin-import-rewards.component.html',
    styleUrls: ['./superadmin-import-rewards.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SuperadminImportRewardsComponent {
  importedRewardsList: any[] = [];
  showNotFoundMsg = true;
  selectedFile: File | null = null;

  constructor(
    private rewardsAdminService: RewardsAdminService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) {}

  onFileSelected(event: any): void {
    this.selectedFile = event.target.files?.[0] || null;
  }

  importRewardJson(): void {
    this.showNotFoundMsg = true;
    this.importedRewardsList = [];
    if (!this.selectedFile) {
      this.showNotFoundMsg = true;
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = (file: ProgressEvent<FileReader>): void => {
      const content: string = (file.target?.result as string) || '';
      try {
        this.importedRewardsList = JSON.parse(content);
        this.showNotFoundMsg = false;
      } catch (error) {
        this.showNotFoundMsg = true;
        console.error('Error parsing JSON file:', error);
      }
    };
    fileReader.readAsText(this.selectedFile);
  }

  async getSelectedImports(selectedRewards: any[]): Promise<void> {
    try {
      await this.rewardsAdminService.importRewards(selectedRewards);
      this.snackBar.open('Importation successfully completed.', 'Close', { duration: 2000 });
      this.router.navigate(['/superadmin/rewards/rewards']).then();
    } catch (error) {
      console.error('Error importing rewards', error);
      this.snackBar.open('Error occurred during importation.', 'Close', { duration: 3000 });
    }
  }
}
